/* ─────────────────────────────────────────────────────────────────────────────
 *  easter-eggs.ts — Easter egg definitions
 * ───────────────────────────────────────────────────────────────────────────── */

export interface SearchEasterEgg {
  triggers: string[];
  cssClass: string;
  duration: number; // ms
}

export const SEARCH_EASTER_EGGS: SearchEasterEgg[] = [
  {
    triggers: ["do a barrel roll", "barrel roll", "z or r twice"],
    cssClass: "barrel-roll",
    duration: 3000,
  },
  {
    triggers: ["askew", "tilt"],
    cssClass: "askew",
    duration: 5000,
  },
  {
    triggers: ["blink html", "blink tag", "<blink>"],
    cssClass: "blink-text",
    duration: 5000,
  },
];

export const KONAMI_SEQUENCE = [
  "ArrowUp", "ArrowUp",
  "ArrowDown", "ArrowDown",
  "ArrowLeft", "ArrowRight",
  "ArrowLeft", "ArrowRight",
  "b", "a",
];

export function matchEasterEgg(query: string): SearchEasterEgg | undefined {
  const q = query.toLowerCase().trim();
  return SEARCH_EASTER_EGGS.find((egg) =>
    egg.triggers.some((t) => q === t)
  );
}
